import React, { useState } from "react";
import { FiUser } from "react-icons/fi";
import { IoMdHeartEmpty } from "react-icons/io";
import { IoCartOutline } from "react-icons/io5";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import Modals from "@/shared/Modal";
import Login from "@/components/user/auth/Login";
import Register from "@/components/user/auth/Register";

const UserActions = ({ isScrolled }) => {
  const [open, setOpen] = useState(false);
  const [isLogin, setIsLogin] = useState(true);
  const navigate = useNavigate();

  const itemCount = useSelector((state) => state.cart.itemCount);
  const user = useSelector((state) => state.auth.user);

  const switchToRegister = () => setIsLogin(false);
  const switchToLogin = () => setIsLogin(true);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleUserIconClick = () => {
    if (user) {
      navigate("/my-account");
    } else {
      handleOpen();
    }
  };

  return (
    <div className="sm:gap-3 gap-1 flex">
      <Link to="/wishlist" className="relative flex group">
        <IoMdHeartEmpty
          className={`sm:h-[24px] sm:w-[24px] h-[20px] w-[20px] my-auto transition-all duration-300 ${
            isScrolled
              ? "text-on-surface group-hover:text-primary"
              : "text-white group-hover:text-primary"
          }`}
        />
      </Link>
      <Link to="/cart" className="relative flex group">
        <IoCartOutline
          className={`sm:h-[24px] sm:w-[24px] h-[20px] w-[20px] my-auto transition-all duration-300 ${
            isScrolled
              ? "text-on-surface group-hover:text-primary"
              : "text-white group-hover:text-primary"
          }`}
        />
        <p className="bg-primary text-[10px] h-4 w-4 flex items-center justify-center text-white rounded-full font-body absolute -top-1 -right-1">
          {itemCount}
        </p>
      </Link>
      <button onClick={handleUserIconClick}>
        <FiUser className="sm:h-8 sm:w-8 h-7 w-7 p-1.5 align-middle rounded-full bg-gradient-to-br from-primary to-primary-container text-white text-xs border border-white/20 my-auto shadow-sm" />
      </button>
      <Modals
        isOpen={open}
        closeModal={handleClose}
        handleClose={handleClose}
        contentLabel="Login Modal"
      >
        {isLogin ? (
          <Login switchToRegister={switchToRegister} />
        ) : (
          <Register switchToLogin={switchToLogin} />
        )}
      </Modals>
    </div>
  );
};

export default UserActions;
